// extracted by mini-css-extract-plugin
export default {"root":"u5FD7C","square":"iyEHCM","cinema":"MAsSyc","child":"H7rFyI"};